import type { BookShipmentShipmentType } from "@/Shared/Types/bookShipmentSliceTypes";
import { useBookShipmentFinishBookingFlow } from "./useBookShipmentFinishBookingFlow";

export function useBookShipmentCompletedFlowItems(
  shipment: BookShipmentShipmentType,
  completedFlowItems: Array<string>,
) {
  const finishBookingFlow = useBookShipmentFinishBookingFlow(shipment);

  function generateUnlockedFlowItems(): Array<string> {
    // Walk through the request quote flow, and then the finish booking flow, and find the first
    // step that hasn't been completed

    const unlockedItems: Array<string> = [];

    for (const item of finishBookingFlow) {
      unlockedItems.push(item.identifier);
      if (!completedFlowItems.includes(item.identifier)) {
        return unlockedItems;
      }
    }

    return unlockedItems;
  }

  const unlockedFlowItems = generateUnlockedFlowItems();

  return {
    unlockedFlowItems,
  };
}
